<template>
  <div v-show="isLoaded" id="retailer" class="mRetailer-section" v-observe-visibility="startAnimate">
    <div class="mSection-title">
      <h2 class="title">Dónde Comprar</h2>
    </div>
    <div class="mFlex-container">
      <div class="mRow">
        <a href="https://super.walmart.com.mx/productos?Ntt=strongbow&utm_source=mtz_heineken&utm_medium=mtz_landing&utm_campaign=mtz_heineken_lf_strongbow_20210311&utm_content=boton&utm_term=landing"
          @click="retailerClick('Walmart')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Walmart" alt="Walmart" />
        </a>
        <a href="https://www.amazon.com.mx/stores/page/AF95D68F-7974-4D85-84BB-C8BC7A147B02?ingress=2&visitId=2a2f2085-fc5e-4791-8117-2041f32fe18a&ref_=ast_bln"
          @click="retailerClick('Amazon')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Amazon" alt="Amazon" />
        </a>
        <a href="https://articulo.mercadolibre.com.mx/MLM-869078325-sidra-strongbow-variety-pack-16-botellas-de-330-ml-_JM?fbclid=IwAR1WMcgMMzS-uqrksFyZwudZwC_78WUktTjelX8MpPt-H5FZ-ZZaJRlcVCE#position=14&search_layout=grid&type=item&tracking_id=3422032d-a96c-4605-9deb-e71726324ec9"
          @click="retailerClick('Mercadolibre')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="MercadoLibre" alt="Mercadolibre" />
        </a>
        <!-- <a href="https://www.heb.com.mx/catalogsearch/result/?q=strongbow"
          @click="retailerClick('Heb')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Heb" alt="Heb" />
        </a> -->
        <!-- <a href="javascript:void(0)"
          @click="retailerClick('Bodega')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Bodega" alt="Bodega" />
        </a> -->
      </div>
      <div class="mRow">
        <a href="https://www.soriana.com/buscar?q=strongbow&cid=&search-button=&page=1"
          @click="retailerClick('Soriana')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Soriana" alt="Soriana" />
        </a>
        <a href="https://web.cornershopapp.com/stores-search/STRONGBOW?fbclid=IwAR0AF93cNRARYF3XMwnQ9Cezanxp0l1thjbIBWIwQJLB1Lx9HiSJRwEzs_k"
          @click="retailerClick('Cornershop')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Cornershop" alt="Cornershop" />
        </a>
        <a href="https://glup.com/"
          @click="retailerClick('Glup')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Glup" alt="Glup" />
        </a>
        <!-- <a href="javascript:void(0)"
          @click="retailerClick('Rappi')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Rappi" alt="Rappi" />
        </a> -->
      </div>
      <div class="mRow">
        <!--<a href="https://www.sixtogo.com.mx/catalogsearch/result/?q=strongbow"
          @click="retailerClick('SixToGo')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="SixToGo" alt="SixToGo" />
        </a>-->
        <!-- <a href="javascript:void(0)"
          @click="retailerClick('CityClub')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="CityClub" alt="CityClub" />
        </a> -->
        <!-- <a href="javascript:void(0)"
          @click="retailerClick('Costco')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="Costco" alt="Costco" />
        </a> -->
        <!-- <a href="javascript:void(0)"
          @click="retailerClick('SamsClub')"
          target="_blank"
          rel="noopener"
          :class="{animate: animate}"
        >
          <img :src="SamsClub" alt="SamsClub" />
        </a> -->
      </div>
    </div>
  </div>
</template>

<script>
import Walmart from "@/assets/WM_ONLINE.png";
import Soriana from "@/assets/SORIANA.png";
import Heb from "@/assets/HEB_ONLINE.png";
import Bodega from "@/assets/BodegaAurrera.png";
import Rappi from "@/assets/Rappi.png";
import Cornershop from "@/assets/Cornershop.png";
import Amazon from "@/assets/Amazon.png";
import MercadoLibre from "@/assets/Mercado_Libre.png";
import SixToGo from "@/assets/SixtoGo.png";
import CityClub from "@/assets/City_Club.png";
import Costco from "@/assets/Costco.png";
import SamsClub from "@/assets/Sams_Club.png";
import Glup from "@/assets/glup.png";
import tagFunctions from '@/utils/tagFunctions.js'
import { mapGetters } from "vuex";

export default {
  name: "Retailers",
  components: {},
  data() {
    return {
      Amazon,
      Cornershop,
      Heb,
      MercadoLibre,
      Rappi,
      SixToGo,
      Walmart,
      Soriana,
      Bodega,
      CityClub,
      Costco,
      SamsClub,
      Glup,
      animate: false
    };
  },
  computed: {
    ...mapGetters(["isLoaded"]),
  },
  mounted() {
  },
  methods: {
    retailerClick(storeName) {
    tagFunctions.evib2cOutboundlinkPush(storeName)
  },
  startAnimate(isVisible) {
    if(isVisible) {
      this.animate=true;
    }
  }
  }
};
</script>

<style lang="scss" scoped>
@import "@/styles/variables.scss";
@import "@/styles/Retailers.scss";
</style>
